export const tr = {
    'banners-max-selected': 'Düzenlemek için en fazla {maxCount} reklam seçin',
    'banners-tab-name': 'Reklamlar',
    'campaigns-tab-name': 'Kampanyalar',
    'export-to-excel-no-banners': 'Kampanyada banner yok',
    'export-to-excel-no-banners-in-group': {
        one: 'Grupta hiç reklam yok',
        some: 'Gruplarda hiç reklam yok',
        many: 'Gruplarda hiç reklam yok',
        none: 'Gruplarda hiç reklam yok'
    },
    'export-to-excel-tooltip': 'Dışa aktarım sadece bir kampanyada yapılabilir',
    'feed-filters-tab-name': 'Besleme filtreleri',
    'groups-max-selected': 'Düzenlemek için en fazla {maxCount} grup seçin',
    'groups-tab-name': 'Gruplar',
    'phrases-tab-name': 'Sözcük grupları',
    'retargetings-tab-name': 'Hedef kitle seçme koşulları',
    'search-and-replace-forbidden-for-relevance-match': 'Otomatik hedefleme için arama ve değiştirme yapılamaz',
    'select-campaigns': 'Kampanyaları seç',
    'targetings-tab-name': 'Gösterim koşulları',
    'users-profile-tab-name': 'Kullanıcı profilleri'
};
